'use client';

import { freddyTheme, Typography } from '@coolblue-development/freddy';

export const SectionTitle = ({ children }: { children: React.ReactNode }) => (
  <Typography
    variant='h2'
    fontSize={{ xs: freddyTheme.typography.h4.fontSize, md: freddyTheme.typography.h2.fontSize }}
    color='inherit'
    mb={200}
  >
    {children}
  </Typography>
);
